import firebase from "firebase";
import "firebase/auth";
import "firebase/analytics";

const config = {
  apiKey: "AIzaSyAh04ZmVChZj8mP8SnORVRYTCXwnJL-CTM",
  authDomain: "nodam-campaign.firebaseapp.com",
  databaseURL: "https://nodam-campaign.firebaseio.com",
  projectId: "nodam-campaign",
  storageBucket: "nodam-campaign.appspot.com",
  messagingSenderId: "757138726642",
  appId: "1:757138726642:web:f3f08b4add29bde8e27a6b",
  measurementId: "G-DFW7QHHFT3",
};
// Initialize Firebase
firebase.initializeApp(config);
// firebase.analytics();

export const auth = firebase.auth();
export const storage = firebase.storage();
export const storageRef = storage.ref();
export const db = firebase.firestore();
export const analytics = firebase.analytics();

export default firebase;
